export enum RequestTypes {
  SELF_MANAGED = 'SELF_MANAGED',
  PROJECT = 'PROJECT',
  HOT_SHOT = 'HOT_SHOT'
}